import { client } from "../../shared/services/client";
import { AxiosResponse } from 'axios'
import LookUpTableModel from '../model/LookUpTableModel'
import LookUpDetailModel from '../model/LookUpDetailModel'
const adminBaseKey = "admin"

export default class LookUpTableAPI {
    getLookUpTables = async (): Promise<LookUpTableModel[]> => {
        client.setBaseURLForService(adminBaseKey)
        const res: AxiosResponse<LookUpTableModel[]> = await client.get<LookUpTableModel[]>("api/LookupDetail/GetLookUpTables");
        return res.data;
    };

    getLookUpDetail = async (tableId: string): Promise<LookUpDetailModel[]> => {
        client.setBaseURLForService(adminBaseKey)
        const res: AxiosResponse<LookUpDetailModel[]> = await client.get<LookUpDetailModel[]>("api/LookupDetail/GetAllLookupDetails?tableId=" + tableId);
        return res.data;
    };

    deleteLookUpDetail = async (id: string): Promise<boolean> => {
        client.setBaseURLForService(adminBaseKey)
        const res = await client.delete<boolean>("api/LookupDetail/DeleteLookupDetail", { data: { id } }
        );
        return res.data;
    }

    saveLookUpDetail = async (model: LookUpDetailModel): Promise<any> => {
        client.setBaseURLForService(adminBaseKey)
        const res: AxiosResponse<any> = (await client.post("api/LookupDetail/AddLookupDetail", model));
        return res.data
    }

    updateLookUpDetail = async (model: LookUpDetailModel): Promise<any> => {
        client.setBaseURLForService(adminBaseKey)
        const res: AxiosResponse<any> = (await client.post("api/LookupDetail/UpdateLookupDetail", model));
        return res.data
    }

    reloadLookupDetailsToCache = async (tableId: string) => {
        client.setBaseURLForService("redisCache")
        const res: AxiosResponse<any> = await client.post("api/WrapperService/ReloadLookupDetailsToCache?tableId=" + tableId);
        return res.data;
    }
}